import MyAccountTabs from './MyAccountTabs';

export default MyAccountTabs;
